import React, {Component} from "react";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import {mapToObjectDDL} from "../../../../common/mapper";
import withFormGroup from "../../../../../modules/commons/withFormGroup";

class MasterLogistikMotorWarnaModifying extends Component {
    discontinueOptions = [
        {
            label: "YES",
            value: true,
        },
        {
            label: "NO",
            value: false,
        },
    ];

    handleSubmit = () => {
        if (this.props.validate()) {
            this.props.onSubmit(this.props.controls);
        }
    };

    render() {
        return (
            <SimpleModal
                title="Form Warna"
                visible={this.props.visible}
                onClickClose={() => this.props.onClickClose()}
                content={
                    <ModalContainer>
                            <SimpleDDL
                                id="select_options_filter_kode_varian"
                                box="search"
                                name="kodeVariant"
                                label="Kode Varian"
                                mandatory
                                errorMessage={this.props.errors.kodeVariant}
                                options={this.props.dataVariantDDL}
                                value={
                                    this.props.controls && Object.keys(this.props.controls).length > 0
                                        ? {
                                            label: this.props.controls.kodeVariant.value.label,
                                            value: this.props.controls.kodeVariant.value.value
                                        }
                                        : undefined
                                }
                                onChange={(value, {name}) =>
                                    this.props.setValue(name, value)
                                }
                            />
                            <SimpleInput
                                id="input_text_id_warna"
                                name="id"
                                label="ID Warna"
                                value={this.props.controls.id.value}
                                readOnly
                            />
                            <SimpleInput
                                id="input_text_kode_warna"
                                name="kodeWarna"
                                label="Kode Warna"
                                value={this.props.controls.kodeWarna.value}
                                onChange={({target}) =>
                                    this.props.setValue(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_nama_warna_pabrik"
                                name="namaWarnaPabrik"
                                label="Nama Warna Pabrik"
                                value={this.props.controls.namaWarnaPabrik.value}
                                onChange={({target}) =>
                                    this.props.setValue(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_nama_warna_komersil"
                                name="namaWarnaKomersil"
                                label="Nama Warna Komersil"
                                value={this.props.controls.namaWarnaKomersil.value}
                                onChange={({target}) =>
                                    this.props.setValue(target.name, target.value)
                                }
                            />
                            <SimpleDDL
                                id="select_options_discontinue"
                                box="search"
                                name="discontinue"
                                label="Discontinue"
                                options={this.discontinueOptions}
                                value={
                                    this.props.controls && Object.keys(this.props.controls).length > 0
                                        ? mapToObjectDDL(
                                            this.props.controls.discontinue.value.label,
                                            this.props.controls.discontinue.value.value,
                                        )
                                        : undefined
                                }
                                onChange={(value, {name}) =>
                                    this.props.setValue(name, value)
                                }
                            />
                            <div style={{textAlign: "center"}}>
                                <SimpleButton onClick={this.handleSubmit}>Simpan</SimpleButton>
                            </div>
                    </ModalContainer>
                }
                />
                );
    }
}

export default withFormGroup(MasterLogistikMotorWarnaModifying);